import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../helpers/classNames";
import { useEditor } from "../../hooks/EditorProvider";
const Typography = ({ component: Component, color, className, children, fontType = "text", ...props }) => {
    const { mode } = useEditor();
    const fontClasses = fontType === "heading" ? "font-heading" : "";
    if (children === '"<br>"' && mode !== "editor")
        return null;
    return (_jsx(Component, { ...props, className: classNames(className, color, fontClasses), dangerouslySetInnerHTML: {
            __html: children,
        } }));
};
export default Typography;
//# sourceMappingURL=Typography.js.map